<mat-card appearance="outlined">
    <app-transformer-top-header [isReadOnly]="isReadOnly" [viewModel]="viewModel" [transformslists]="transformslists" [iconpath]="iconpath" [nodeColor]="nodeColor" [transformNameType]="transformNameType" [aboutlink]="aboutlink"
    [refineryConfigGuid]="refineryConfigGuid" [refineryName]="refineryName" [nodeName]="nodeName" [nodeIndex]="nodeIndex" [configGuid]="configGuid" [cacheStatus]="cacheStatus" (onRefreshCacheStatus)="getCacheStatus()" (onPurgeCache)="purgeCache()"
    (onTransformTextChanged)="onTransformTextChanged()" 
    (onViewTransformConfigJson)="viewTransformConfigJson()" 
    (onRunTransform)="onRunTransform()" 
    (onSaveConfig)="saveConfig()" (onShowTransformDetail)="showTransformDetail($event)" (onImportTransformer)="loadImportTransformer($event)" [hasResetSupport]="true" (onResetTransform)="resetTransformer()"
    [inputCacheKey]="copilotInputCacheKey"
    [sourceColumn]="viewModel?.parameters?.sourceColumn ?? ''"
    [availableSourceFields]="eventGroupNamerAvailableSourceFields"
    [currentSampleStart]="viewModel?.parameters?.sampleStart ?? 0"
    [currentSampleEnd]="viewModel?.parameters?.sampleEnd ?? 0"
    (onApplySmartSample)="applySmartSample($event)"></app-transformer-top-header>
    
    <mat-card-content class="content-with-fixed-header">
        <!-- Description -->
        <mat-expansion-panel class="mat-elevation-z0" style="margin-top:5px;">
            <mat-expansion-panel-header>Description</mat-expansion-panel-header>
            <app-transformer-description [analystDescription]="viewModel.transform.analystDescription"
                (analystDescriptionChange)="viewModel.transform.analystDescription = $event"></app-transformer-description>
        </mat-expansion-panel>
        <!-- Parameters -->
        <mat-expansion-panel class="mat-elevation-z0" expanded style="margin-top: 5px;">
            <mat-expansion-panel-header>Parameters<span *ngIf="isValidateParameters" class="mat-error" style="margin-left: 5px;">Missing Required Fields</span></mat-expansion-panel-header>
         <div style="margin-top:-10px;margin-left: -3px;">
            <app-transformer-parameters [viewModel]="viewModel.parameters" [sourceColumns]="viewModel.sourceColumnsDT" 
                (SetDefaultRule)="onSetDefaultRule($event)" 
                (ToggleRulesColumnDisplay)="onToggleRulesColumnDisplay()" 
                (formStatus)="onParameterFormStatusChange($event)"></app-transformer-parameters>
            <div style="display: flex">
                <div style="margin-right: 10px;">
                    <div style="display: flex; align-items: center;" [formGroup]="formparam">
                              <app-autocomplete-field-with-matform
                    formControlName="groupByField"
                    [options]="viewModel.OptionsourceColumns"
                     [placeholder]="groupBy.label|| 'Group By'"
                    [(ngModel)]="viewModel.groupBy"
                    [isrequired]="true"
                   
                ></app-autocomplete-field-with-matform>
                        <!-- <mat-form-field [formGroup]="formparam" appearance="legacy" style="width: 100%;">
                            <mat-label>{{groupBy.label}}</mat-label>
                            <mat-select required formControlName="groupByField" [(ngModel)]="viewModel.groupBy">
                                <mat-option *ngIf="groupBy.isselectblank"></mat-option>
                                <mat-option *ngFor="let col of viewModel.sourceColumns" [value]="col.text">
                                    {{col.text}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="formparam.get('groupByField').hasError('required')">{{viewModel.getValidationInfo('groupByField').errorMessage}}</mat-error>
                        </mat-form-field> -->
                    </div>
                     <div style="flex-basis: 100%; width: 100%;">
                <mat-error *ngIf="formparam.get('groupByField')?.hasError('required') && 
                                    formparam.get('groupByField')?.touched">
                    {{ groupBy.label }} is required
                </mat-error>
                </div>
                </div>
                
                <div style="margin-right: 10px;">
                    <div>
                        <mat-form-field>
                            <mat-label>{{defTimeout.label}}</mat-label>
                            <input matInput placeholder="Timeout" type="number" [min]="defTimeout.min" [max]="defTimeout.max"
                                [(ngModel)]="viewModel.defTimeout" appIntegerPositiveOnly>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            </div>
        </mat-expansion-panel>
        <!-- Advanced Settings -->
        <mat-expansion-panel class="mat-elevation-z0" style="margin-top: 15px;">
            <mat-expansion-panel-header>Advanced Settings<span *ngIf="isValidateAdvanceSettings" class="mat-error" style="margin-left: 5px;">Missing Required Fields</span></mat-expansion-panel-header>
            <div style="display: flex">
                <div style="margin-right: 10px;margin-top:-10px;margin-left: -2px;">
                    <div>
                        <mat-form-field [formGroup]="form">
                            <mat-label>{{bufferRows.label}}</mat-label>
                            <input matInput formControlName="bufferRows" type="number" placeholder="Buffer Rows" [(ngModel)]="viewModel.bufferRows" [required]="bufferRows.isrequired" [min]="bufferRows.min" [max]="bufferRows.max" appIntegerPositiveOnly>
                        </mat-form-field>
                    </div>
                    <div>
                        <mat-form-field [formGroup]="form">
                            <mat-label>{{threads.label}}</mat-label>
                            <input matInput formControlName="threads" type="number" placeholder="Threads" [(ngModel)]="viewModel.threads" [required]="threads.isrequired" [min]="threads.min" [max]="threads.max" appIntegerPositiveOnly>
                        </mat-form-field>
                    </div>
                    <div>
                        <mat-form-field [formGroup]="form">
                            <mat-label>{{searchWildCard.label}}</mat-label>
                            <input matInput formControlName="searchWildCard" type="text" placeholder="search Wild Card" [(ngModel)]="viewModel.searchWildCard" [required]="searchWildCard.isrequired" >
                        </mat-form-field>
                    </div>
                </div>
                <div style="margin-right: 10px;">
                    <div>
                        <mat-form-field [formGroup]="form">
                            <mat-label>{{orderField.label}}</mat-label>
                            <mat-select [(ngModel)]="viewModel.orderField" [required]="orderField.isrequired" formControlName="orderField">
                                <mat-option *ngIf="orderField.isselectblank"></mat-option>
                                <mat-option *ngFor="let col of viewModel.targetColumns" [value]="col">{{col}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="form.get('orderField').hasError('required')">OrderField Field is required</mat-error>
                        </mat-form-field>
                    </div>
                    <div>
                        <mat-form-field [formGroup]="form">
                            <mat-label>{{isOpenField.label}}</mat-label>
                            <mat-select [(ngModel)]="viewModel.isOpenField" [required]="isOpenField.isrequired" formControlName="isOpenField">
                                <mat-option *ngIf="isOpenField.isselectblank"></mat-option>
                                <mat-option *ngFor="let col of viewModel.targetColumns" [value]="col">{{col}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="form.get('isOpenField').hasError('required')">IsOpenField Field is required</mat-error>
                        </mat-form-field>
                    </div>
                    <div>
                        <mat-form-field [formGroup]="form">
                            <mat-label>{{isCloseField.label}}</mat-label>
                            <mat-select [(ngModel)]="viewModel.isCloseField" [required]="isCloseField.isrequired" formControlName="isCloseField">
                                <mat-option *ngIf="isCloseField.isselectblank"></mat-option>
                                <mat-option *ngFor="let col of viewModel.targetColumns" [value]="col">{{col}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="form.get('isCloseField').hasError('required')">IsCloseField Field is required</mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div style="margin-right: 10px;">
                    <div>
                        <mat-slide-toggle style="margin-left: 10px;margin-right: 10px;margin-bottom: 10px;" labelPosition="before" color="primary" (change)="onToggleMultiTarget($event)" [checked]="viewModel.multiTargetColumn" ><span [innerHTML]="multiTargetColumn.label"></span></mat-slide-toggle>
                    </div>
                    <div>
                        <mat-slide-toggle style="margin-left: 10px;margin-right: 10px;margin-bottom: 20px;" labelPosition="before" color="primary" (change)="onToggleSpaceSeparator($event)" [checked]="viewModel.spaceSeparator" ><span [innerHTML]="spaceSeparator.label"></span></mat-slide-toggle>
                    </div>
                    <div>
                        <mat-slide-toggle style="margin-left: 10px;margin-right: 10px;margin-bottom: 10px;" labelPosition="before" color="primary" (change)="onToggleRemoveRedundant($event)" [checked]="viewModel.removeRedundant" ><span [innerHTML]="removeRedundant.label"></span></mat-slide-toggle>
                    </div>
                </div>
            </div>
        </mat-expansion-panel>
        <!-- Rules -->
        <mat-expansion-panel class="mat-elevation-z0" expanded  style="padding-top: 10px;">
            <mat-expansion-panel-header>
                <div style="display: flex; align-items: center; justify-content: center;">
                    <span style="margin-right: 30px;">Rules</span>

                    <button  class="add-rule-btn" 
                        color="primary" mat-raised-button (click)="$event.stopPropagation(); addNewRule()"
                        title="Add new rule"  style="height: 24px;border-radius: 2px;">
                        <mat-icon >add_circle</mat-icon>
                        ADD RULE
                    </button>

                    <button (click)="$event.stopPropagation(); toggleRulesHeight();"
                         color="primary"
                        mat-raised-button title="Show All" class="rule-toggle-btn" style=" line-height: 24px;height: 24px;border-radius: 2px;">
                        <mat-icon >{{isRulesMaximized ? 'unfold_less' : 'unfold_more'}}
                        </mat-icon>
                        <!-- {{isRulesMaximized ? 'MINIMIZE' : 'MAXIMIZE'}} -->
                    </button>

                </div>

            </mat-expansion-panel-header>
            <!-- [style.max-height.px]="isRulesMaximized ? '100000' : '386'" -->
            <div 
                style="margin-top: 0px; margin-left: -6px; margin-right: -6px; padding-left: 6px; padding-right: 6px;" class="show-scrollbar"
                appMatTableAdjustRowHeight [RowCount]="isRulesMaximized ? maxrowcount : minrowcount" [MaxRowCount]="maxrowcount" [IsScrollBottom]="isScrollBottom">
                <h1 class="center" style=" color: lightgray" *ngIf="isRuleSetEmpty">No Rules</h1>

                <table *ngIf="!isRuleSetEmpty" (cdkDropListDropped)="dropTable($event)" mat-table
                    [dataSource]="dataSource" #table class="drag-list mat-elevation-z8" cdkDropList
                    [cdkDropListData]="dataSource">

                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef class="no-padding-cell"> </th>
                        <td mat-cell *matCellDef="let rule" class="no-padding-cell">

                            <div style="display: flex; flex-direction: row; justify-content: flex-start; align-items: center">
                               <!-- <mat-icon color="primary" matTooltip="Re-order Rule"  style="cursor: grab" cdkDrag [cdkDragData]="rule"
                                    cdkDragRootElement=".drag-component" cdkDragHandle>reorder</mat-icon>
                                <mat-icon style="margin-left: 4px; cursor: pointer" class="icon" (click)="onDuplicateRule(rule)" matTooltip="Duplicate Rule" color="primary">control_point_duplicate</mat-icon>
                                <mat-icon style="margin-left: 2px; cursor: pointer" (click)="onDeleteRule(rule)" matTooltip="Delete Rule" class="red-icon">delete_forever</mat-icon>
                            -->
                                                    <!-- Reorder Icon -->
                        <mat-icon
                        color="primary"
                        matTooltip="Re-order Rule"
                        matTooltipPosition="above"
                        #reorderTip="matTooltip"
                        (mouseenter)="reorderTip.show(); duplicateTip.hide(); deleteTip.hide()"
                        (mouseleave)="reorderTip.hide()"
                        style="cursor: grab;"
                        cdkDrag
                        [cdkDragData]="rule"
                        cdkDragRootElement=".drag-component"
                        cdkDragHandle
                        >reorder</mat-icon>

                        <!-- Duplicate Icon -->
                        <mat-icon
                        style="margin-left: 6px; cursor: pointer;"
                        class="icon"
                        matTooltip="Duplicate Rule"
                        matTooltipPosition="above"
                        #duplicateTip="matTooltip"
                        (mouseenter)="duplicateTip.show(); reorderTip.hide(); deleteTip.hide()"
                        (mouseleave)="duplicateTip.hide()"
                        (click)="onDuplicateRule(rule)"
                        color="primary"
                        >control_point_duplicate</mat-icon>

                        <!-- Delete Icon -->
                        <mat-icon
                        style="margin-left: 6px; cursor: pointer;"
                        matTooltip="Delete Rule"
                        matTooltipPosition="above"
                        #deleteTip="matTooltip"
                        (mouseenter)="deleteTip.show(); reorderTip.hide(); duplicateTip.hide()"
                        (mouseleave)="deleteTip.hide()"
                        (click)="onDeleteRule(rule)"
                        class="red-icon"
                        >delete_forever</mat-icon>
                           
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="index">
                        <th mat-header-cell *matHeaderCellDef> Rule </th>
                        <td mat-cell *matCellDef="let rule"> {{rule.index}} </td>
                        <mat-icon cdkDragHandle>reorder</mat-icon>
                    </ng-container>

                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef> Rule Name </th>
                        <td mat-cell *matCellDef="let rule"><input type="text"
                                style="border: none; box-sizing: border-box" [(ngModel)]="rule.ruleName" appAutowidth>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="sourceField" >
                        <th mat-header-cell *matHeaderCellDef> Source Field </th>
                        <td mat-cell *matCellDef="let rule" class="auto-width">
                             <!-- <mat-select [(ngModel)]="rule.sourceColumn">
                                <mat-option *ngFor="let col of viewModel.sourceColumns" [value]="col.text">{{col.text}}
                                </mat-option>
                            </mat-select> -->
                               <app-autocomplete-field 
                                [options]="options"    
                                [placeholder]="defaultSourceColumn" 
                                [(ngModel)]="rule.sourceColumn"
                                ></app-autocomplete-field>  
                        </td>
                        <mat-icon cdkDragHandle>reorder</mat-icon>
                    </ng-container>

                    <ng-container matColumnDef="targetField">
                        <th mat-header-cell *matHeaderCellDef> Target Field </th>
                        <td mat-cell *matCellDef="let rule" class="auto-width">
                            <mat-select [(ngModel)]="rule.targetColumn">
                                <!-- <mat-option></mat-option> -->
                                <mat-option *ngFor="let col of viewModel.targetColumns" [value]="col">{{col}}
                                </mat-option>
                            </mat-select>
                        </td>
                        <mat-icon cdkDragHandle>reorder</mat-icon>
                    </ng-container>

                    <ng-container matColumnDef="actionString">
                        <th style="border-left: 1px solid #ffa600 !important; color: #99ff00 !important" mat-header-cell *matHeaderCellDef>
                            Action String(s) <span class="mat-form-field-required-marker">*</span></th>
                        <td mat-cell *matCellDef="let rule"
                            [style.text-align]="!rule.actionString || rule.actionString?.length === 0 ? 'center' : 'left'"
                            style="max-width: 400px; text-overflow: ellipsis; white-space: nowrap;
                        overflow: hidden; cursor: pointer; border-left: 1px solid #ffa600 !important;"
                            (click)="onColoredTextCellClicked('actionString', rule)">
                            <span *ngIf="!rule.actionString || rule.actionString?.length === 0"
                                style="margin-left: 2px; margin-right: 2px; color: #ffa600 !important; font-size:10px; white-space: pre;">Tap
                                to Edit</span>
                            <span style="margin-left: 2px; margin-right: 2px; white-space: pre;"
                                *ngFor="let item of rule.actionString"
                                [style.color]="item.color.color">{{item.text}}</span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="objectString">
                        <th style="border-left: 1px solid #ffa600 !important; color: #ff9933 !important" mat-header-cell *matHeaderCellDef>
                            Object String(s) </th>
                        <td mat-cell *matCellDef="let rule"
                            [style.text-align]="!rule.objectString || rule.objectString?.length === 0 ? 'center' : 'left'"
                            style="max-width: 400px; text-overflow: ellipsis; white-space: nowrap;
                        overflow: hidden; cursor: pointer; border-left: 1px solid #ffa600 !important;"
                            (click)="onColoredTextCellClicked('objectString', rule)">
                            <span *ngIf="!rule.objectString || rule.objectString?.length === 0"
                                style="margin-left: 2px; margin-right: 2px; color: #ffa600 !important; font-size:10px; white-space: pre;">Tap
                                to Edit</span>
                            <span style="margin-left: 2px; margin-right: 2px; white-space: pre;"
                                *ngFor="let item of rule.objectString"
                                [style.color]="item.color.color">{{item.text}}</span>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="timeout">
                        <th mat-header-cell *matHeaderCellDef style="border-left: 1px solid #ffa600 !important;text-align: center;"> Timeout (s) </th>
                        <td mat-cell *matCellDef="let rule" style="border-left: 1px solid #ffa600 !important;">
                            <input type="number" style="width: 100%; border: none; box-sizing: border-box" [(ngModel)]="rule.timeout" appIntegerPositiveOnly>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="priorityString">
                        <th mat-header-cell *matHeaderCellDef style="text-align: center;"> Priority String  </th>
                        <td mat-cell *matCellDef="let rule">
                            <mat-select [(ngModel)]="rule.priorityString">
                                <mat-option *ngFor="let priorityStringType of PriorityStringTypes" [value]="priorityStringType">
                                    {{PriorityStringTypeUtil.toString(priorityStringType)}}
                                </mat-option>
                            </mat-select>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="includeAction">
                        <th mat-header-cell *matHeaderCellDef> Include Action?
                        </th>
                        <td mat-cell *matCellDef="let rule">
                            <mat-slide-toggle color="primary" [(ngModel)]="rule.includeAction"></mat-slide-toggle>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="ignoreSpaces">
                        <th mat-header-cell *matHeaderCellDef> Ignore Space?
                        </th>
                        <td mat-cell *matCellDef="let rule">
                            <mat-slide-toggle color="primary" [(ngModel)]="rule.ignoreSpaces"></mat-slide-toggle>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="matchCase">
                        <th mat-header-cell *matHeaderCellDef> Match CASE? </th>
                        <td mat-cell *matCellDef="let rule">
                            <mat-slide-toggle color="primary" [(ngModel)]="rule.matchCase"></mat-slide-toggle>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="isEnabled">
                        <th mat-header-cell *matHeaderCellDef> Run? &nbsp;&nbsp;&nbsp;<mat-slide-toggle (change)="onRunChanged($event)"
                                color="primary"></mat-slide-toggle>
                        </th>

                        <td mat-cell *matCellDef="let rule">
                            <mat-slide-toggle color="primary" [(ngModel)]="rule.run"></mat-slide-toggle>
                        </td>
                    </ng-container>


                    <ng-container matColumnDef="sampleGroups">
                        <th mat-header-cell style="border-left: 1px solid #ffa600 !important;" *matHeaderCellDef> Sample Group Hits
                        </th>
                        <td mat-cell style="border-left: 1px solid #ffa600 !important;" *matCellDef="let rule">
                            {{rule.sampleGroupHits | number}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="sampleRows">
                        <th mat-header-cell *matHeaderCellDef> Sample Row Hits</th>
                        <td mat-cell *matCellDef="let rule"> {{rule.sampleRowHits | number}} </td>
                    </ng-container>

                    <ng-container matColumnDef="groups">
                        <th mat-header-cell *matHeaderCellDef> Total Group Hits</th>
                        <td mat-cell *matCellDef="let rule"> {{rule.groupHits | number}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="rows">
                        <th mat-header-cell *matHeaderCellDef> Total Row Hits</th>
                        <td mat-cell *matCellDef="let rule"> {{rule.rowHits | number}} </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>
                    <!--<tr class="drag-component" mat-row *matRowDef="let row; columns: displayedColumns;"></tr>-->
                    <tr
                    class="drag-component"
                    mat-row
                    *matRowDef="let row; columns: displayedColumns;"
                    (click)="onRowClicked($event, row)"
                    [ngClass]="{'highlight-row': selectedRows.includes(row)}">
                    </tr>

                    <div *cdkDragPlaceholder></div>
                </table>
            </div>
        </mat-expansion-panel>
        <!-- Results Dashboard -->
        <mat-expansion-panel class="mat-elevation-z0" [expanded]="isResultsPanelExpanded">
            <mat-expansion-panel-header (click)="setTaskResultsTabClicked()">Results Dashboard</mat-expansion-panel-header>
            <mat-tab-group animationDuration="300ms" [(selectedIndex)]="resultsDashboardTabIndex">
                <mat-tab label="Results">
                    <div style="position: relative">
                          <div style="position: absolute;left:200px;top: 4px; ">
                            <mat-form-field style="width: 120px" appearance="outline">
                                <mat-label>Farm Rows</mat-label>
                                <input readonly matInput placeholder="Rows" type="text" [value]="viewModel.rows | number">
                            </mat-form-field>
                            <mat-form-field style="width: 110px; margin-left: 3px;" appearance="outline">
                                <mat-label>Group Hits</mat-label>
                                <input type="text" readonly matInput placeholder="Hits"
                                    [value]="viewModel.groupHitCount | number">
                            </mat-form-field>
                            <mat-form-field style="width: 92px; margin-left: 3px;" appearance="outline">
                                <mat-label>Row Hits</mat-label>
                                <input type="text" readonly matInput placeholder="Hits" [value]="viewModel.hitCount | number">
                            </mat-form-field>
                            <mat-form-field style="width: 130px; margin-left: 3px;" appearance="outline">
                                <mat-label>Row Hit Ratio</mat-label>
                                <input type="text" readonly matInput placeholder="Row Hit Ratio"
                                    [(ngModel)]="viewModel.hitRatioDisplay">
                            </mat-form-field>
                            <mat-form-field style="width: 90px; margin-left: 3px;" appearance="outline">
                                <mat-label>Misses</mat-label>
                                <input type="text" readonly matInput placeholder="Misses"
                                    [value]="viewModel.missCount | number">
                            </mat-form-field>
                            <mat-form-field *ngIf="lastDtrRunTime" style="width: 120px; margin-left: 3px;" appearance="outline">
                                <mat-label>Uncompiled</mat-label>
                                <input type="text" readonly matInput [value]="lastDtrRunTime"
                                    matTooltip="Run Time (uncompiled) — time taken by the generic engine to execute this transform" matTooltipPosition="above">
                            </mat-form-field>
                            <mat-form-field *ngIf="lastDtrRunTime && isCompilable" style="width: 120px; margin-left: 3px;" appearance="outline">
                                <mat-label>When compiled</mat-label>
                                <input type="text" readonly matInput [value]="lastCompiledRunTime"
                                    matTooltip="Preview only — how fast the compiled fast-path engine would run this transform's CURRENT config (saved or not), not necessarily what production is using right now. Save to make this the actual compiled plan production runs. NA when the config isn't fully compilable or its own Run All Rows setting is off." matTooltipPosition="above">
                            </mat-form-field>
                        </div>
                        <app-preview-table [delegate]="this" #previewTable [hideRefresh]="true" [hideOptions]="true" previewType="temptransResult" previewTypeName="Result"
                            [viewModel]="previewDataViewModel"  ></app-preview-table>
                    </div>
                </mat-tab>
                <mat-tab label="Summary">
                    <button mat-raised-button color="primary" [matMenuTriggerFor]="menusummaryResult" #menuTriggerResult="matMenuTrigger"  style="margin-top: 3px;margin-left: 20px;margin-right: 50px;" (click)="showSelectFilterResult(menuTriggerResult)">Summary Fields</button>
                    <span>{{ totalSummaryRowsResult }}</span>
                    <mat-menu #menusummaryResult="matMenu" yPosition="below" style="margin-top: 2% !important;">
                        <app-select-filter-option [values]="selectValuesResult" [valuesColor]="selectValuesColorResult" [sources]="datafarmSourcesResult" [source]="sourceResult" [emptyColumns]="selectEmptyColumnsResult" [selectedColumns]="selectFilterValuesResult" columnName="Summary" (clearFilter)="onClearSelectResult($event)" (applyFilter)="onApplySelectResult($event)" (closeFilter)="onCloseSelectResult()"></app-select-filter-option>
                    </mat-menu>
                    <app-preview-table style="width: 100px;" [delegate]="this" #summaryDataFarmPreviewTableResult [hideRefresh]="true" previewType="Summary" 
                        [hideOptions]="true" [viewModel]="previewDataViewModel" [widthOptions]="true"  ></app-preview-table>
                </mat-tab>
            </mat-tab-group>
        </mat-expansion-panel>
        <!-- Data Farm Preview -->
        <mat-expansion-panel class="mat-elevation-z0" [expanded]="isPreviewPanelExpanded">
            <mat-expansion-panel-header (click)="setTaskPreviewTabClicked()">Data Farm Preview</mat-expansion-panel-header>
            <mat-tab-group animationDuration="300ms" (selectedTabChange)="onTabClick($event)">
                <mat-tab label="Input ({{inputcolumncount}})">
                    <div style="position: relative;">
                        <app-preview-table [delegate]="this" #inputDataFarmPreviewTable [hideRefresh]="true"
                            [hideOptions]="true" [viewModel]="previewDataViewModel" previewType="transInput" previewTypeName="Input"  ></app-preview-table>
                    </div>
                </mat-tab>
                <mat-tab label="Output ({{outputcolumncount}})">
                    <app-preview-table [delegate]="this" #outputDataFarmPreviewTable [hideRefresh]="true"
                        [hideOptions]="true" [viewModel]="previewDataViewModel" previewType="temptransOutput" previewTypeName="Output"  ></app-preview-table>
                </mat-tab>
                <mat-tab label="Summary (Input)">
                    <button mat-raised-button color="primary" [matMenuTriggerFor]="menusummaryinput" #menuTriggerInput="matMenuTrigger"  style="margin-top: 3px;margin-left: 20px;margin-right: 50px;" (click)="showSelectFilter(menuTriggerInput,'Input')">Summary Fields</button>
                    <span>{{ totalSummaryRowsInput }}</span>
                    <mat-menu #menusummaryinput="matMenu" yPosition="below" style="margin-top: 2% !important;">
                        <app-select-filter-option [values]="selectValuesInput" source="Input" [emptyColumns]="selectEmptyColumnsInput" [selectedColumns]="selectFilterValuesInput" columnName="Summary" (clearFilter)="onClearSelect($event)" (applyFilter)="onApplySelect($event)" (closeFilter)="onCloseSelect()" (changeSource)="onChangeSource($event)"></app-select-filter-option>
                    </mat-menu>
                    <app-preview-table style="width: 100px;" [delegate]="this" #summaryDataFarmPreviewTableInput [hideRefresh]="true" previewType="Summary" 
                        [hideOptions]="true" [viewModel]="previewDataViewModel" [widthOptions]="true"  ></app-preview-table>
                </mat-tab>
                <mat-tab label="Summary (Output)">
                    <button mat-raised-button color="primary" [matMenuTriggerFor]="menusummaryoutput" #menuTriggerOutput="matMenuTrigger"  style="margin-top: 3px;margin-left: 20px;margin-right: 50px;" (click)="showSelectFilter(menuTriggerOutput,'Output')">Summary Fields</button>
                    <span>{{ totalSummaryRowsOutput }}</span>
                    <mat-menu #menusummaryoutput="matMenu" yPosition="below" style="margin-top: 2% !important;">
                        <app-select-filter-option [values]="selectValuesOutput" source="Output" [emptyColumns]="selectEmptyColumnsOutput" [selectedColumns]="selectFilterValuesOutput" columnName="Summary" (clearFilter)="onClearSelect($event)" (applyFilter)="onApplySelect($event)" (closeFilter)="onCloseSelect()" (changeSource)="onChangeSource($event)"></app-select-filter-option>
                    </mat-menu>
                    <app-preview-table style="width: 100px;" [delegate]="this" #summaryDataFarmPreviewTableOutput [hideRefresh]="true" previewType="Summary" 
                        [hideOptions]="true" [viewModel]="previewDataViewModel" [widthOptions]="true"  ></app-preview-table>
                </mat-tab>
            </mat-tab-group>
        </mat-expansion-panel>
        <!-- Data Farm Export -->
        <mat-expansion-panel [disabled]="isDisabled" [expanded]="!isDisabled" class="mat-elevation-z0">
            <mat-expansion-panel-header (click)="DataFarmExport()">Data Farm Export</mat-expansion-panel-header>
            <app-export-output-data #exportOutputData [hideOptions]="true" 
            [viewModelExport]="viewModelExport"></app-export-output-data>
        </mat-expansion-panel>
    </mat-card-content>
</mat-card>